import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
// import Fonts from "../middle.screen.parent.component/Fonts";
import TextSettings from "./TextSettings";
import AnimatedTextSettings from "./AnimatedTextSettings";
import CharacterSettings from "./CharacterSettings";
import StaticShapesSettings from "./StaticShapesSettings";
import AnimatedShapesSettings from "./AnimatedShapesSettings";
import ImageSettings from "./ImageSettings";
import VideoSettings from "./VideoSettings";
import SoundSettings from "./SoundSettings";
import { editLayerMotion } from "./MotionOverlay";
import { hasMotion } from "../../Utils/layerMotion";

// "Movement" at the top of every layer's settings: opens the A → Z path editor on the canvas.
const MovementSettings = ({ item }) => {
  const { LayersData } = useContext(MyContext);
  if (!item || item.type === "audio" || item.key === undefined) return null;
  const layer = (LayersData || []).find((l) => l.key === item.key) || item;
  const moving = hasMotion(layer);
  return (
    <div className="LabelWithSlider" style={{ marginBottom: 12 }}>
      <div className="settingsTitle mb-2">Movement</div>
      <button
        type="button"
        onClick={() => editLayerMotion(layer.key)}
        disabled={!!layer.lock}
        title={layer.lock ? "Unlock the layer first" : "Set a start (A) and end point (Z) on the canvas"}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          padding: "8px 10px",
          borderRadius: 6,
          border: "1px solid #296AFF",
          background: moving ? "#fff" : "#296AFF",
          color: moving ? "#296AFF" : "#fff",
          fontWeight: 600,
          cursor: layer.lock ? "not-allowed" : "pointer",
          opacity: layer.lock ? 0.5 : 1,
        }}
      >
        <span className="material-icons" style={{ fontSize: 18 }}>moving</span>
        {moving ? "Edit move A → Z" : "Move from A to Z"}
      </button>
      <div style={{ fontSize: 11, opacity: 0.75, marginTop: 4 }}>
        {moving
          ? `Moves in ${Number(layer.Motion.duration).toFixed(1)} s` +
            (Number(layer.Motion.delay) > 0 ? `, starting ${Number(layer.Motion.delay).toFixed(1)} s in` : "") +
            ". Tip: right-click any layer for quick actions."
          : "Tip: right-click any layer on the canvas for quick actions."}
      </div>
    </div>
  );
};
const SettingsMenu = (props) => {
  const { editableObject } = useContext(MyContext);
  //console.log(editableObject);
  return (
    <>
      <div className="settingsMenuPanel scrollbar style-1">
        <MovementSettings item={editableObject.editableItem} />
        {editableObject.editableItem.type === "text" && (
          <TextSettings></TextSettings>
        )}
        {editableObject.editableItem.type === "AnimatedText" && (
          <AnimatedTextSettings></AnimatedTextSettings>
        )}
        {editableObject.editableItem.type === "Character" && (
          <CharacterSettings></CharacterSettings>
        )}
        {editableObject.editableItem.type === "basicShape" && (
          <StaticShapesSettings></StaticShapesSettings>
        )}
        {editableObject.editableItem.type === "Props" && (
          <AnimatedShapesSettings></AnimatedShapesSettings>
        )}
        {editableObject.editableItem.type === "Shape" && (
          <StaticShapesSettings></StaticShapesSettings>
        )}
        {editableObject.editableItem.type === "image" && (
          <ImageSettings></ImageSettings>
        )}
        {editableObject.editableItem.type === "Video" && (
          <VideoSettings></VideoSettings>
        )}
        {editableObject.editableItem.type === "audio" && (
          <SoundSettings></SoundSettings>
        )}
      </div>
    </>
  );
};
export default SettingsMenu;
